import { values } from "lodash-es";

const parseNetworkError = (e) => {
  const errBody = e?.response?.data;
  let errString = errBody;
  if (typeof errBody === "string") {
    errString = errBody;
  } else if (typeof errBody === "object") {
    errString = values(errBody).join(". ");
  } else if (Array.isArray(errBody)) {
    // this.action = action;
    errString = errBody.join(". ");
  }

  return errString;
};

export { parseNetworkError };
